import { useI18n } from '@cascade/react/i18n';
import { Button } from '@cascade/ui-library';
import clsx from 'clsx';
import { getToggleIcon } from './Header.helpers.ts';
import classes from './Header.module.scss';
import { Logo } from '#components/logo/index.ts';
import { useLayout } from '#layout/Layout.context.ts';

export const Header = () => {
  const { translate } = useI18n();
  const { isRegular, isSidebarOpen, toggleSidebar } = useLayout();

  const showLogo = !isRegular || isSidebarOpen;
  const toggleIcon = getToggleIcon(isRegular, isSidebarOpen);

  return (
    <header className={clsx(classes.header, { [classes.docked]: isRegular })}>
      {showLogo ? <Logo /> : null}
      <Button
        ghost
        iconOnly
        variant='secondary'
        iconType={toggleIcon}
        label={translate('navigation.toggle')}
        className={clsx(classes.toggle, { [classes['with-logo']]: showLogo })}
        onClick={toggleSidebar}
      />
    </header>
  );
};
